import { useRef } from "react";
import { Button, Text, useInterval } from "@chakra-ui/react";

import { usePersistStore } from "../../../../store/persistStore";
import { useOTPMutationReaction } from "../PhoneNumberForm/hooks";
import { useLoginFormStore } from "../../../../store/loginFormStore";
import { isNewAuthorization } from "../../../../store/authorizationStore";
import { ESMSFormState } from "../../../../store/slices/smsFormSliceCreator";

/**
 * A timer that displays the number of seconds remaining before a user can request the SMS code again.
 */
export function SMSResendTimer() {
  const resendLock = useRef(false);
  const smsState = useLoginFormStore(state => state.smsFormState);
  const checkingSMS = isNewAuthorization() && smsState !== ESMSFormState.initial;
  const timer = usePersistStore(state => state.timer);
  const tick = usePersistStore(state => state.tick);
  const getEscapedPhoneNumber = useLoginFormStore(state => state.getEscapedPhoneNumber);

  const sendOtp = useOTPMutationReaction();

  useInterval(tick, 1000);

  const handleResendClick = () => {
    if (sendOtp.isPending || checkingSMS || resendLock.current) {
      return;
    }

    resendLock.current = true;
    sendOtp.mutate({ phone: getEscapedPhoneNumber() }, { onSettled: () => {
      resendLock.current = false;
    } });
  };

  if (timer === 0) {
    return (
      <Button
        onClick={handleResendClick}
        isDisabled={sendOtp.isPending || checkingSMS}
        colorScheme="brand"
        variant="link"
        color="purple.500"
      >
        Отправить код еще раз
      </Button>
    );
  }

  return (
    <Text size="sm" align="center">
      Повторить отправку через
      {" "}
      {timer}
      {" "}
      сек
    </Text>
  );
}
